var map = {
	"./facebook.png": 717,
	"./facebook_light.png": 363,
	"./instagram.png": 306,
	"./instagram_light.png": 871,
	"./linkedin.png": 93,
	"./linkedin_light.png": 800,
	"./twitter.png": 3,
	"./twitter_light.png": 761,
	"./x.png": 341,
	"./x_light.png": 575,
	"./youtube.png": 10,
	"./youtube_light.png": 262
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78;